import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import AdminNavigation from '../Inc/AdminNavigation';
import { notification, Input, Button, Icon, Divider, Card, DatePicker,Popconfirm, Spin, Pagination, Select,Menu, Dropdown, Modal, message, Row, Col, Form, InputNumber } from 'antd';
import * as actions from "../../actions/index";
import { compose } from "recompose";
import { history } from '../../container/History';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment"
import { withRouter } from "react-router-dom";
import debounce from 'lodash.debounce';
import InputMask from 'react-input-mask'
import './PromoCode.css'

const FormItem = Form.Item;
const Option = Select.Option;
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
}

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;


const menu = (props, promoCode) => {
    let isDeletablePromoCode = false
    if (promoCode.quantityUsed == 0) {
        isDeletablePromoCode = true
    } 
    
    return(
    <Menu>
        <Menu.Item key={promoCode.id}>
            <a target="_blank" onClick={() => history.push({
                pathname: '/Add-Promo-Code-Portal',
                state: { promoCode }
            })} >
                Edit Promotion Code
            </a>
        </Menu.Item>
        <Menu.Item>

            <Popconfirm placement="bottomLeft" title={isDeletablePromoCode ? "Are you sure to delete this Promo Code?" : 'Promo code is active and cannot be deleted.'} onConfirm={() => { 
               if (isDeletablePromoCode) {
                props.actions.deletePromoCode(promoCode.id)
               } 
              
                }} okText={isDeletablePromoCode ? "Yes" : 'OK'} cancelText={isDeletablePromoCode ? "No" : 'Cancel'}>
                {/* <i className="fa fa-trash-o red pointer fa-lg" aria-hidden="true" > */}
                    <a target="_blank" >
                        Delete Promotion Code
                    </a>
                {/* </i> */}
            </Popconfirm>


        </Menu.Item>

    </Menu>
)};

class PromoCode extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props,
            preference: { "Formula": '', "Expressions": [] },
            quicksearch: {},
            formvalues: {},
            Home_State: '',
            lookUpID: [1858, 1859],
            PromoValue: ['$', '%'],
            currency: '',
            SearchByPromoName: '',
            noPromoCodeFound: false,
            searchPromoCodeInputValue: '',

        }
    }

    states = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates
            return statesarray.map((k, index) => {
                return (
                    <option key={k.id} value={k.name.split('-')[1]}>{k.short}</option>
                )
            })
        }
    }

    removeFilter = () => {
        this.props.form.resetFields()
    }

    Eaglestates = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates
            return statesarray.map((k, index) => {
                return (
                    <option key={k.id} value={k.short}>{k.short}</option>
                )
            })
        }
    }

   

    componentDidMount = (e) => {
        this.props.actions.GetPromoCodes()
    }
    
    SearchByPromoName = (e) => {
            e.preventDefault();
            this.props.form.validateFieldsAndScroll((err, values) => {
                !err &&
            this.props.actions.GetPromoCodes(values.searchPromoCode) 
    })
    }

    renderPromoCodeSearchButton = () => {
        return  <Button type="primary width-100 save-change-btn" htmlType="submit" style={{ margin: '0px' }}
        loading={this.props.searching_PromoCode}
        >
        {/* <i class="fa fa-search margin-right-5" aria-hidden="true"></i> */}
            {this.props.searching_PromoCode ? 'Searching' : 'Search'}
       </Button>
    }

    renderPromoAmountLookUpID = () => {
        return this.state.lookUpID.map((type, index) => {
            return (
                <option key={type} value={type}>{type}</option>
            )
        })
    }

    renderPromoValue = () => {
        return this.state.PromoValue.map((type, index) => {
            return (
                <option key={index} value={type}>{type}</option>
            )
        })
    }
    changeCurrencyMask = (value) => {
        if (value.length > 0) {
            let v = Number(value)
            let currency = (v).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').split('.')[0];
            this.setState({
                currency
            })
            this.props.form.setFieldsValue({
                quantityAllowed: currency
            }); //quantityAllowed

        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.PromoCode_Deleted != nextProps.PromoCode_Deleted) {
            Modal.success({
                className: "ErrorModal",
                title: 'Success',
                content: "PromoCode deleted successfully!",
                onOk() {
                }
            });
            this.props.actions.GetPromoCodes()
        }
        if (this.props.searching_PromoCode && !nextProps.searching_PromoCode) {
        if (nextProps.PromoCodes){
            if (nextProps.PromoCodes.length == 0 ) {
                // const getPromoCodes = () => this.props.actions.GetPromoCodes()
                this.showNoPromoCodeFoundModal()
                // Modal.error({
                //     className: "ErrorModal",
                //     title: 'Not Found!',
                //     content: "No Record Found!",
                //     onOk() {
                //         getPromoCodes()
                //     }
                // });
            }
            }
        }
    }
    closeNoPromoCodeFoundModal = () =>{
        this.setState({
            noPromoCodeFound: false
        })
    }
    showNoPromoCodeFoundModal = () =>{
        this.setState({
            noPromoCodeFound: true
        })
    }

    renderPromoCodes = () => {
        if (this.props.getting_PromoCodes || this.props.searching_PromoCode) {
            return <Col span={24}>
                <Spin indicator={LoadingIcon} className="loading-state" tip={this.props.searching_PromoCode ? 'Searching Promo Code...' : "Loading Promo Codes..."} />
            </Col>

        } else if (this.props.PromoCodes) {
            let PromoCodes = this.props.PromoCodes
            return this.props.PromoCodes.map(promocode => {
                return <Col xs={20} sm={20} md={10} lg={7} xl={7} className='PromoCards' >
                        <div>
                            <Row>
                                <Col span={22} >
                                    <div className='PromoCards-Title'>
                                        {promocode.promoCode}
                                    </div>
                                </Col>
                                <Col span={2}>
                                    <div style={{cursor: 'pointer'}}>
                                        <Dropdown overlay={() => menu(this.props, promocode)} placement="bottomRight" >
                                            <span className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                                <i class="fa fa-ellipsis-v margin-right-5" aria-hidden="true"></i>
                                            </span>
                                        </Dropdown>
                                        <span>
    
                                        </span>
                                    </div>
                                </Col>
                            </Row>
    
                            <div>
                                <Row >
                                    <div className='PromoCards-SubTitle'>
                                        Promo Description:
                                    </div>
                                    <div className='PromoCards-content'>
                                        {promocode.promoDescription}
                                    </div>
                                </Row>
                                <Row >
                                    <div className='PromoCards-SubTitle'>
                                        Promo ID:
                                    </div>
                                    <div className='PromoCards-content'>
                                        {promocode.id}    
                                    </div>
                                </Row>
                                <Row >
                                    <div className='PromoCards-SubTitle'>
                                        Organization GUID:
                                    </div>
                                    <div className='PromoCards-content'>
                                    {promocode.organizationGuid}    
                                    </div>
                                </Row>
                                <Row >
                                    <div className='PromoCards-SubTitle'>
                                        Promo Amount LookUp ID:
                                    </div>
                                    <div className='PromoCards-content'>
                                    {promocode.amountTypeId} 
                                    </div>
                                </Row>
                                <Row >
                                    <div className='PromoCards-SubTitle'>
                                        Promo Value:
                                    </div>
                                    <div className='PromoCards-content'>
                                    {promocode.value} 
                                    </div>
                                </Row>
                                <Row >
                                    <div className='PromoCards-SubTitle'>
                                        Promo Product Type ID:
                                    </div>
                                    <div className='PromoCards-content'>
                                    {promocode.productTypeId} 
                                    </div>
                                </Row>
                                <Row >
                                    <div className='PromoCards-SubTitle'>
                                        Promo Product Program ID:
                                    </div>
                                    <div className='PromoCards-content'>
                                    {promocode.productProgramId} 
                                    </div>
                                </Row>
                                <Row >
                                    <div className='PromoCards-SubTitle'>
                                        Quantity Allowed:
                                    </div>
                                    <div className='PromoCards-content'>
                                    {promocode.quantityAllowed} 
                                    </div>
                                </Row>
                                <Row >
                                    <div className='PromoCards-SubTitle'>
                                        Quantity Used:
                                    </div>
                                    <div className='PromoCards-content'>
                                    {promocode.quantityUsed} 
                                    </div>
                                </Row>
                                <Row >
                                    <div className='PromoCards-SubTitle'>
                                        Effective Date:
                                    </div>
                                    <div className='PromoCards-content'>
                                    {moment(promocode.effectiveDt).format('MM-DD-YYYY')} 
                                    </div>
                                </Row>
                                <Row >
                                    <div className='PromoCards-SubTitle'>
                                        Expiry Date:
                                    </div>
                                    <div className='PromoCards-content'>
                                    {moment(promocode.expiryDt).format('MM-DD-YYYY')} 
                                    </div>
                                </Row>
                            </div>
                        </div>
                    </Col>
    
            })
        }
    }
    handleInputChange = (e) => {
        this.setState({ searchPromoCodeInputValue: e.target.value });
      };
    
      handleClearInput = () => {
        this.setState({ searchPromoCodeInputValue: '' });
        this.props.form.setFieldsValue({searchPromoCode: ''});
        // this.props.form.resetFields();
        this.props.actions.GetPromoCodes();
      };
    
    validateURICharacters = (rule, value, callback) => {
        const uriPattern = /[^-A-Za-z0-9-\s*$_.!~*'()]/;
    
        if (uriPattern.test(value)) {
          callback('Not allowed characters ( <, >, ", #, %, {, }, |, \, ^, ~, [, ], `)');
        } else {
          callback();
        }
      };

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const quicksearch = this.state.quicksearch
        return (
            <div>
                <LayoutHeader />

                <AdminNavigation />
                <div className='promoContainer'>
                    <div className='my-profile alumni-profile'>
                        <Row style={{ display: 'flex', alignItems: 'center' }}>
                            <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                                <div className="text-result pointer" onClick={() => {
                                    history.push('/admin-dashboard')
                                 }} >
                                    <i class="fa fa-lg fa-long-arrow-left margin-right-5"></i> Back to Dashboard</div>
                            </Col>

                        </Row>

                        <Row style={{ display: 'flex', alignItems: "center", flexWrap: 'wrap' }} >
                            <Col xs={24} sm={24} md={13} lg={13} xl={13} >
                                <div className='PromoTitle'>
                                    Promo Code Portal
                                </div>
                            </Col>

                            <Col xs={0} sm={0} md={2} lg={4} xl={4} >

                            </Col>
                            <Col xs={24} sm={24} md={9} lg={7} xl={7}  >
                                <div className='alumni-ui top-margin'>
                                    <Button type="primary width-100  save-change-btn" htmlType="submit" style={{ margin: '0px' }} onClick={() => { history.push('/Add-Promo-Code-Portal') }}>
                                        <i class="fa fa-plus-circle margin-right-5" aria-hidden="true"></i>
                                        Create New Promo Code
                                    </Button>
                                </div>
                            </Col>

                        </Row>

                        {/* <div className='widget'>
                            <div className='widget-container dashboard-search'>
                                <div className="widget-header">
                                   
                                </div>

                                

                            </div>
                        </div> */}
                        <div className='tab-container' style={{ margin: '30px 0px 0px' }}>
                            <Form className='searchform alumni-ui' onSubmit={this.SearchByPromoName} style={{width: '100%'}} >
                                <Row>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        {/* {
                                        // this.props.isadmin == true &&
                                        // this.MembershipDownload()
                                        <div className="content-filter" style={{ background: "transparent", fontSize: '15px', padding: "10px 0px", fontWeight: 'normal', justifyContent: 'flex-start' }}>
                                            {/* {this.props.NESApendingMembershipCSV ? */}
                                        {/* <label className="downloadBtn pointer" >
                                                <Button type='default' style={{ color: "#515354", background: "transparent", border: 'none' }}
                                                    onClick={() => {
                                                        // this.setState({ membershipType: "processed" })
                                                        // this.showDownloadCSV_pending_modal()
                                                    }}
                                                >
                                                    Download CSV
                                                    <i className="fa fa-cloud-download margin-left-5" style={{ fontSize: '20px' }}></i>
                                                </Button>
                                            </label>
                                        </div>
                                    } */}
                                    </Col>
                                    <Col xs={0} sm={0} md={4} lg={4} xl={4} >
                                    </Col>
                                    <Col xs={18} sm={18} md={10} lg={10} xl={10}>
                                        {/* <Input name="txt_search"
                                        onChange={(e) =>  this.SearchByPromoName(e)}
                                        className="searchInput" size="small" prefix={< Icon type="search" />} placeholder="Search by Promo Code Name" /> */}
                                        <FormItem
                                        style={{marginBottom: '0px'}}
                                        className="searchPromoCodeInput"
                                        >
                                            {getFieldDecorator('searchPromoCode', {
                                                initialValue: this.state.searchPromoCodeInputValue,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Enter the PromoCode Name',
                                                    },
                                                    {
                                                        pattern: /^[\S]+$/,
                                                        message: 'White Space not allowed!',
                                                    },
                                                    {
                                                        validator: this.validateURICharacters, // Use the custom validation function
                                                    },
                                                ],
                                            })(
                                                <div style={{ position: 'relative' }}>
                                                    <Input name="txt_search"
                                                    id='searchPromoCode'
                                                        prefix={< Icon type="search" />}
                                                        placeholder="Search by Promo Code Name"
                                                        maxLength={50}
                                                        onChange={this.handleInputChange}
                                                        value = {this.state.searchPromoCodeInputValue}
                                                    />
                                                    {this.state.searchPromoCodeInputValue && (
                                                        <Icon
                                                            type="close-circle"
                                                            style={{
                                                                position: 'absolute',
                                                                right: 8,
                                                                top: '50%', transform: 'translateY(-50%)' ,
                                                                cursor: 'pointer',
                                                            }}
                                                            onClick={this.handleClearInput}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                    <FormItem  style={{marginBottom: '0px', padding: '0px'}}>
                           {this.renderPromoCodeSearchButton()}
                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        <div className='tab-body'>
                            <div className='PromoCards-Container'>
                            
                             <Row type='flex' className='PromoCards-contentArea' align='center' justify='center' style={{width: '100%'}}>
                                {this.renderPromoCodes()}
                                </Row>
                            </div>
                        </div>

                    </div>
                </div>


            <Modal
                    className='No-records-match-myMrofile-model'
                    title={false}
                    footer={false}
                    visible={this.state.noPromoCodeFound}
                    centered
                    onCancel={() => {
                        this.setState({ searchPromoCodeInputValue: '' })
                        this.props.form.setFieldsValue({searchPromoCode: ''});
                        this.closeNoPromoCodeFoundModal();
                        this.props.actions.GetPromoCodes();
                    }}
                //    closable={false}
                >
                    <div className="center">
                        {/* <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                         */}

                        <div className='margin-bottom-20 PromoTitle' style={{marginTop: '20px', color: "#000000a6"}}> No Record Found!</div>

                        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                                <div className='step-container margin-top-20' >
                                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                         this.closeNoPromoCodeFoundModal();
                                         this.props.actions.GetPromoCodes();
                                         this.setState({ searchPromoCodeInputValue: '' })
                                         this.props.form.setFieldsValue({searchPromoCode: ''});
                                        //  this.props.form.resetFields();
                                    }} htmlType='submit'>CLOSE </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
        

            </div>
        );
    }

}



function mapStateToProps(state) {
    return {
        searching_PromoCode: state.getPromoCodeReducer.searching,
        getting_PromoCodes: state.getPromoCodeReducer.loading,
        PromoCodes: state.getPromoCodeReducer.promoCodes,
        get_PromoCodesErr: state.getPromoCodeReducer.err,

        adding_PromoCodes: state.addPromoCodeReducer.loading,
        PromoCode_Added: state.addPromoCodeReducer.response,
        Add_PromoCodeErr: state.addPromoCodeReducer.err,

        updating_PromoCodes: state.updatePromoCodeReducer.loading,
        PromoCode_Updated: state.updatePromoCodeReducer.response,
        update_PromoCodeErr: state.updatePromoCodeReducer.err,

        deleting_PromoCodes: state.deletePromoCodeReducer.loading,
        PromoCode_Deleted: state.deletePromoCodeReducer.response,
        Delete_PromoCodeErr: state.deletePromoCodeReducer.err,
        
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

const PromoCodePortal = Form.create()(PromoCode);


export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(PromoCodePortal);


// WEBPACK FOOTER //
// ./src/components/PromoCode/PromoCode.js